import { render, staticRenderFns } from "./AdvisorySavingsQuestions.vue?vue&type=template&id=1522b1e2&scoped=true"
import script from "./AdvisorySavingsQuestions.vue?vue&type=script&lang=js"
export * from "./AdvisorySavingsQuestions.vue?vue&type=script&lang=js"
import style0 from "./AdvisorySavingsQuestions.vue?vue&type=style&index=0&id=1522b1e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522b1e2",
  null
  
)

export default component.exports